import React from 'react';

/** Small full-area spinner while auth role is resolving (avoids blank screens). */
export function RouteAuthSpinner() {
  return (
    <div className="flex min-h-[40vh] w-full items-center justify-center bg-slate-50">
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-domio-600 border-t-transparent" />
    </div>
  );
}
